import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import { useTranslation } from 'react-i18next';

const ContactMessageContent = ({ contact }) => {
  const { t } = useTranslation();

  if (!contact) {
    return <Typography variant="body2">{t('messages.contact.contactUnavailable')}</Typography>;
  }

  return (
    <Stack sx={{ paddingX: 2, paddingY: 1}} direction="row" spacing={1} alignItems="center">
      <PersonIcon fontSize="small" />
      <Box>
        <Typography variant="subtitle2" sx={{ wordBreak: 'break-word' }}>
          {contact.name || t('messages.contact.contact')}
        </Typography>
        {contact.phoneNumber && (
          <Typography variant="caption" display="block" color="text.secondary">
            {contact.phoneNumber}
          </Typography>
        )}
      </Box>
    </Stack>
  );
};

export default ContactMessageContent;
